import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	content: {
		alignItems: 'center',
		flexDirection: 'row',
		paddingVertical: 10,
	},

	radio: {
		marginRight: 10,
	},

	label: {
		height: 20,
	},
});
